module.exports = __webpack_public_path__ + "img/Menu-07.8f0bc7f6.png";